import React, { useState, useEffect } from "react";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";

export const DragAndDropPrep = (props) => {
  const { items } = props;

  const [preparations, setPreparations] = useState([]);

  const reorder = (list, startIndex, endIndex) => {
    const result = [...list];
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
  };

  useEffect(() => {
    setPreparations(items);
  }, [items]);

  return (
    <>
      <DragDropContext
        onDragEnd={(result) => {
          const { source, destination } = result;
          if (!destination) {
            return;
          }
          if (
            source.index === destination.index &&
            source.droppableId === destination.droppableId
          ) {
            return;
          }

          setPreparations((prevPreparations) =>
            reorder(prevPreparations, source.index, destination.index)
          );
        }}
      >
        <Droppable droppableId="preparations" direction="horizontal">
          {(droppableProvided) => (
            <div
              {...droppableProvided.droppableProps}
              ref={droppableProvided.innerRef}
              className="flex-container"
              style={{ display: "flex", flexDirection: "row" }}
            >
              {preparations.length > 0 &&
                preparations.map((preparation, index) => (
                  <Draggable
                    key={preparation.id}
                    draggableId={preparation.id}
                    index={index}
                  >
                    {(draggableProvided) => (
                      <div className="p-5 m-1">
                        <div
                          className="bg-white p-5 m-1"
                          {...draggableProvided.draggableProps}
                          ref={draggableProvided.innerRef}
                          {...draggableProvided.dragHandleProps}
                        >
                          {preparation.name}
                        </div>
                      </div>
                    )}
                  </Draggable>
                ))}
              {preparations.length === 0 && (
                <p className="m-5 ">
                  Añade ingredientes para ordenar las preparaciones...
                </p>
              )}
              {droppableProvided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
      <input
        hidden={true}
        value={preparations.map((ing) => {
          return ing.id;
        })}
        id="preparation_order"
        name="preparation_order"
      ></input>
    </>
  );
};
